export default [
  {
    disableBeacon: true,
    target: "#tour-training-items",
    title: "Train your team in compliance and cybersecurity with engaging videos",
    content: "Your training portal will host tons of videos on compliance to get your team up to speed.",
    placement: "top"
  }
]


// WEBPACK FOOTER //
// ./src/components/tour/training/steps.js